import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import localForage from "localforage";
import ApplicationInstance from "./modules/applicationInstance";
import PriceGuard from "./modules/priceguard";
import Notifier from "./modules/notifier";
import NavigationBar from "./modules/navigationBar";
import Settings from "./modules/settings";
import Authentication from "./modules/authentication";
import Notifications from "./modules/notifications";

localForage.config({
  driver: localForage.INDEXEDDB,
  name: "dealio",
  storeName: "store",
  description: "Dealio data storage.",
});

const vuexLocal = new VuexPersistence({
  storage: localForage,
  asyncStorage: true,
  modules: ["notifier"],
});

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    instances: ApplicationInstance,
    priceguard: PriceGuard,
    notifier: Notifier,
    navigationBar: NavigationBar,
    settings: Settings,
    authentication: Authentication,
    notifications: Notifications,
  },
  plugins: [vuexLocal.plugin],
  strict: process.env.NODE_ENV !== 'production'
});
